<div class="dialog-header">
    <h2 mat-dialog-title>Net Current Assets Forecast</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="ncaForm">
    <div class="key-value-pair-section">
        <div class="key-value-pair-column" style="flex: 1;">
            <div>
                <valumize-mergeable-date
                    [label]="'Exit Date Assumption'"
                    [isEditable]=true
                    [control]=ncaForm.controls.exitDateAssumption
                    [isMandatory]="true">
                </valumize-mergeable-date>
                <valumize-mergeable-number-input
                    [label]="'Low'"
                    [isEditable]=true
                    [control]=ncaForm.controls.lowNca
                    [type]="'currency'"
                    [isMandatory]="true">
                </valumize-mergeable-number-input>
                <valumize-mergeable-number-input
                    [label]="'Base'"
                    [isEditable]=true
                    [control]=ncaForm.controls.baseNca
                    [type]="'currency'"
                    [isMandatory]="true">
                </valumize-mergeable-number-input>
                <valumize-mergeable-number-input
                    [label]="'High'"
                    [isEditable]=true
                    [control]=ncaForm.controls.highNca
                    [type]="'currency'"
                    [isMandatory]="true">
                </valumize-mergeable-number-input>
            </div>
        </div>
    </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-stroked-button mat-dialog-close
        color="primary"
        data-test="save-button"
        [disabled]="ncaForm.invalid"
        (click)="save()">
        Save
    </button>
</mat-dialog-actions>
